import { useState, useRef, useEffect } from "react";
import "./Select.css";

const CustomSelect = ({
  options,
  value,
  onChange,
  name,
  width,
  height,
  heightOption = "280px",
  color = "#000000",
  fontSize = "14px",
  textAlign = "left",
  fontWeight = "400",
  paddingTop = "3px",
  marginBottom = "20px",
  placeholder = "Seleccione un perfil",
  overflowY = "hidden",
  topOption = "-175px",
  isDisabled = false,
  placeholderCustom = false,
  marginLeft = false,
  caretColor = "#62C776", // 👈 color de la flecha
  optionsWidth = "252px",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const selectedOption = options?.find((option) => option.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const capitalize = (text) =>
    text
      .toLowerCase()
      .split(" ")
      .map((word, index) => {
        if (
          ["HSEQ", "IMSS", "INE", "DC3", "REPSE", "SUA", "SIPARE"].includes(
            word.toUpperCase()
          )
        ) {
          return word.toUpperCase();
        }
        return index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word;
      })
      .join(" ");

  const handleSelect = (selectedValue) => {
    onChange({
      target: {
        name,
        value: selectedValue.value,
        innerHTML: selectedValue.name,
      },
    });
    setIsOpen(false);
  };

  return (
    <div style={{ position: "relative", zIndex: 1 }} ref={selectRef}>
      {/* Control */}
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "3px 10px",
          background: "white",
          cursor: isDisabled ? "not-allowed" : "pointer",
          width,
          height,
          fontFamily: "Nunito",
          fontSize,
          fontWeight,
          marginBottom,
          marginLeft,
          color,
          paddingTop,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          userSelect: "none",
        }}
        onClick={() => !isDisabled && setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span style={{ textAlign }}>
          {placeholderCustom
            ? `${placeholderCustom} ${
                selectedOption ? capitalize(selectedOption.name) : "Todos"
              }`
            : selectedOption
            ? capitalize(selectedOption.name)
            : placeholder}
        </span>

        {/* Flecha CSS */}
        <span
          style={{
            display: "inline-block",
            transition: "transform 120ms ease",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <span
            style={{
              display: "inline-block",
              width: 0,
              height: 0,
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderTop: `6px solid ${caretColor}`, // 👈 color de la flecha
            }}
          />
        </span>
      </div>

      {/* Opciones */}
      {isOpen && !isDisabled && (
        <div
          role="listbox"
          style={{
            position: "absolute",
            top: topOption,
            left: 0,
            width: optionsWidth,
            border: "1px solid #ccc",
            background: "white",
            padding: "5px",
            zIndex: 1000,
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            overflowY,
            height: heightOption,
            color,
            textAlign: "left",
          }}
        >
          {options.map((option) => (
            <div
              key={option.value}
              className="options"
              role="option"
              aria-selected={option.value === value}
              style={{
                padding: "1px 10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                marginBottom: "1px",
                fontWeight,
                zIndex: 1500,
                background:
                  option.value === value ? "rgba(0,0,0,0.04)" : "transparent",
              }}
              onClick={() => handleSelect(option)}
            >
              {option.icon && (
                <img
                  src={option.icon}
                  alt={option.name}
                  style={{ width: "15px", height: "15px", marginRight: "8px" }}
                />
              )}
              {capitalize(option.name)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
